import { dateValidator, plaintextValidator } from '../fields';

const config = { mandatory: true };

function getTicketConstraints(isMSPProduct) {
  let conditions = {
    name: {
      presence: {
        allowEmpty: false,
        message: '^Enter schedule name'
      }
    },
    subject: {
      presence: {
        allowEmpty: false,
        message: '^Enter ticket subject'
      }
    }
  };
  if (isMSPProduct) {
    conditions = {
      ...conditions,
      'client.accountId': {
        presence: {
          allowEmpty: false,
          message: '^Client must be selected'
        }
      }
    };
  } else {
    conditions = {
      ...conditions,
      'site.id': {
        presence: {
          allowEmpty: false,
          message: '^Site must be selected'
        }
      }
    };
  }
  return conditions;
}

// const prefix = 'scheduleDefinition.data.';
const prefix = '';

const getMonthType = (type) => {
  switch (type) {
    case 'DAY_OF_MONTH':
      return { [`${prefix}dayOfMonth`]: plaintextValidator(config) };
    case 'WEEK_OF_MONTH':
      return {
        [`${prefix}week`]: plaintextValidator(config),
        [`${prefix}dayOfWeek`]: plaintextValidator(config)
      };
    default:
      return {};
  }
};

const getEndType = (endType) => {
  switch (endType) {
    case 'AfterNRuns':
      return {
        [`${prefix}repeatCount`]: plaintextValidator(config)
      };
    case 'AfterDateTime':
      return {
        [`${prefix}endDateAndTime`]: plaintextValidator(config)
      };
    default:
      return {
        endType: plaintextValidator(config)
      };
  }
};

const getScheduleObject = (type, monthType, endType) => {
  const baseCondition = {
    [`${prefix}startDateAndTime`]: plaintextValidator(config),
    [`${prefix}repeatInterval`]: plaintextValidator(config),
    [`${prefix}endType`]: plaintextValidator(config),
    ...getEndType(endType)
  };
  switch (type) {
    case 'WEEKLY':
      return {
        [`${prefix}dayOfWeek`]: plaintextValidator(config),
        ...baseCondition
      };
    case 'MONTHLY':
      return {
        [`${prefix}type`]: plaintextValidator(config),
        // week: plaintextValidator(config),
        // dayOfWeek: plaintextValidator(config),
        // dayOfMonth: plaintextValidator(config), //only if type is DAY_OF_MONTH and not WEEK_OF_MONTH
        ...getMonthType(monthType),
        ...baseCondition
      };
    case 'ONCE':
      return {
        [`${prefix}startDateAndTime`]: plaintextValidator(config)
      };
    case 'HOURLY':
    case 'DAILY':
    default:
      return baseCondition;
  }
};

export default (formToValidate, isMSPProduct) => {
  const { frequency, type: monthType, endType } = formToValidate;
  return {
    ...getTicketConstraints(isMSPProduct),
    ...getScheduleObject(frequency, monthType, endType)
  };
};
